import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import {
  CoinsFaceValueDTO,
  CoinsFaceValueGiftingDTO,
  CoinsFaceValueInfoVo,
  GamePassItemDTO,
  GamePassItemVo,
  OrderDeliveryDTO,
  SpuRelevantDataVo
} from './type';

// getCoinsFaceValueInfo2GamePass
// GET /product/urlMapping/b2c/getCoinsFaceValueInfo2GamePass
// 接口ID：375030785
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-375030785
export const coinsFaceValueInfo2GamePass = (params: CoinsFaceValueDTO): AxiosPromise<CoinsFaceValueInfoVo[]> => {
  return request({
    url: '/product/urlMapping/b2c/getCoinsFaceValueInfo2GamePass',
    method: 'get',
    params
  });
};

// getGamePassItem
// GET /product/urlMapping/b2c/getGamePassItem
// 接口ID：375030784
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-375030784
export const gamePassItem = (params: GamePassItemDTO): AxiosPromise<GamePassItemVo[]> => {
  return request({
    url: '/product/urlMapping/b2c/getGamePassItem',
    method: 'get',
    params
  });
};

// getOffer2Gifting
// GET /product/urlMapping/b2c/getOffer2Gifting
// 接口ID：375030783
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-375030783
export const offer2Gifting = (params: CoinsFaceValueGiftingDTO): AxiosPromise<CoinsFaceValueInfoVo> => {
  return request({
    url: '/product/urlMapping/b2c/getOffer2Gifting',
    method: 'get',
    params
  });
};

// 获取boblox robux头部信息
export const robloxTabInfo = (): AxiosPromise<SpuRelevantDataVo[]> => {
  return request({
    url: '/product/urlMapping/b2c/getTabInfo',
    method: 'get'
  });
};

// 订单保存发货信息
// POST /order/order/buyer/save/getItem/info
// 接口ID：375370889
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-375370889
export const robloxSaveOrderDeliveryInfo = (data: OrderDeliveryDTO): AxiosPromise<boolean> => {
  return request({
    url: '/order/order/buyer/save/getItem/info',
    method: 'post',
    data
  });
};
